import { render, staticRenderFns } from "./FaqCard.vue?vue&type=template&id=487fa6de&scoped=true&"
import script from "./FaqCard.vue?vue&type=script&lang=js&"
export * from "./FaqCard.vue?vue&type=script&lang=js&"
import style0 from "./FaqCard.vue?vue&type=style&index=0&id=487fa6de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fa6de",
  null
  
)

export default component.exports